import AlbumFolderBranding from './AlbumFolderBranding';

export default AlbumFolderBranding;
